<template>
    <div class="tb-box">
        <div class="banner-box" >
            <img src="./img-tb/dingbu-banner-tuya.png" alt="" @click="clickJump" loading="lazy">
        </div>
        <div class="bom-main">
            <div class="bom-main-center">
                <div class="common1">
                    <div class="comm-lis">
                        <p>经常听到老板抱怨</p>
                        <p>交代的工作没结果</p>
                        <p>员工工作不积极</p>
                        <p>九零后不好管…</p>
                    </div>
                    <div class="comm-lis comm-lis2">
                        <div class="top-lis">
                            <img src="./img-tb/shou1.png" alt="" class="left-img" loading="lazy">
                            <img src="./img-tb/tbLOGO.png" alt="" class="logo-tb" loading="lazy">
                            <img src="./img-tb/shou2.png" alt="" class="right-img" loading="lazy">
                        </div>
                        <div class="bom-lis">
                            不是团队不够优秀，是你需要一款好的协同工具
                        </div>
                    </div>
                    <div class="comm-lis">
                        <p>公司有好的战略还不够</p>
                        <p>好的战略靠执行</p>
                        <p>好的执行靠团队</p>
                        <p>好的团队靠协同</p>
                    </div>
                </div>
                <div class="common2">
                    Teambition，是阿里巴巴集团旗下一款以项目、任务为核心的数字化协同产品。自上线以来，产品注册用户已超过1000万并已服务包含:制造业、互联网、零售、金融、地产、教育、交通等领域上万家付费企业。打通厚重的部门墙，让团队高效协同，从Teambition开始!
                </div>
                <div class="comm-title">丰富产品能力，满足团队各级角色需要</div>
                <div class="common3">
                    <div class="comm3-lis">
                        <img src="./img-tb/iimg-new-ss1.png" alt="" loading="lazy">
                        <p class="ps1">领导把控全局</p>
                        <p class="ps2">数据组合明晰权责分工，一站式可视化管理，即刻提高组织执行力</p>
                    </div>
                    <div class="comm3-lis">
                        <img src="./img-tb/guanlizhezhangkong.png" alt="" loading="lazy">
                        <p class="ps1">管理者掌控过程</p>
                        <p class="ps2">多种项目视图项目进度可见、可控、可管理，实现有始有终的闭环管理</p>
                    </div>
                    <div class="comm3-lis">
                        <img src="./img-tb/zhixingzhe.png" alt="" loading="lazy">
                        <p class="ps1">执行者心中有数</p>
                        <p class="ps2">深入融合钉钉自动汇集任务，提高工作跟进效率，轻松完成工作事</p>
                    </div>
                </div>
                <div class="comm-title title-s2">优秀团队是如何用Teambition做项目管理的？</div>
                <div class="common4">
                    <div class="common4-lis">
                        <div class="com-lis-left">
                            <p class="pp1">项目启动 <span>有模板</span></p>
                            <p class="pp2">项目启动初期，</p>
                            <p class="pp2 pps2">应该如何规划流程和项目关键节点？</p>
                            <p class="pp3 pp3s1">Teambition提供了大量项目管理、产品设计、敏捷开发、订单交付、</p>
                            <p class="pp3 pp3s2">销售管理等多种行业、场景的实践案列模板，<span>一键复用，轻松上手</span></p>
                            <div class="liubai"></div>
                            <span class="bntn-box" @click="clickJump">立即了解</span>
                        </div>
                        <div class="com-lis-right">
                            <img src="./img-tb/79371f5e5cf7336ba80818613f42379c_01-b83fab01f5b92d01e42f8295bc0e57b4-tuya.png" alt="" loading="lazy">
                        </div>
                    </div>
                    <div class="common4-lis common4-lis-ts">
                        <div class="com-lis-left">
                            <img src="./img-tb/kanban.png" alt="" loading="lazy">
                        </div>
                        <div class="com-lis-right">
                            <p class="pp1">项目规划 <span>找看板</span></p>
                            <p class="pp2">同步进行的项目很多，</p>
                            <p class="pp2 pps2">管理者如何做好规划、掌握全局？</p>
                            <p class="pp3 pp3s1">用Teambition，可以将项目任务的各个阶段分解到不同的人，实现精细化规划，</p>
                            <p class="pp3 pp3s2">掌握节奏。同时，Teambition还提供多种视图随需切换，让任务清晰可见<span>让任务清晰可见</span></p>
                            <div class="liubai"></div>
                            <span class="bntn-box" @click="clickJump">立即了解</span>
                        </div>
                    </div>
                    <div class="common4-lis">
                        <div class="com-lis-left">
                            <p class="pp1">项目执行 <span>盯任务</span></p>
                            <p class="pp2">员工同时执行多个任务</p>
                            <p class="pp2 pps2">如何区分轻重缓急？</p>
                            <p class="pp3 pp3s1">Teambition以任务为中心展开协作，执行者直观查看任务数量和重要</p>
                            <p class="pp3 pp3s2">程度和时间规划，<span>让任务管理，有始有终</span></p>
                            <div class="liubai"></div>
                            <span class="bntn-box" @click="clickJump">立即了解</span>
                        </div>
                        <div class="com-lis-right">
                            <img src="./img-tb/renwu.png" alt="" loading="lazy">
                        </div>
                    </div>
                    <div class="common4-lis common4-lis-ts">
                        <div class="com-lis-left">
                            <img src="./img-tb/jindu-tuya.png" alt="" loading="lazy">
                        </div>
                        <div class="com-lis-right">
                            <p class="pp1">项目进度 <span>查统计 </span></p>
                            <p class="pp2">如何把控项目进度，</p>
                            <p class="pp2 pps2">了解项目风险把控进度？</p>
                            <p class="pp3 pp3s1">Teambition提供完善项目管理看板，多维度统计分析视觉，让</p>
                            <p class="pp3 pp3s2">您轻松<span>掌控项目风险，把控全局</span></p>
                            <div class="liubai"></div>
                            <span class="bntn-box" @click="clickJump">立即了解</span>
                        </div>
                    </div>
                </div>
                <div class="common3 common-3ss">
                    <div class="comm3-lis">
                        <img src="./img-tb/xiangmuguanli.png" alt="" loading="lazy">
                        <p class="ps1">项目管理 细致专业</p>
                        <p class="ps2">将项目管理方法产品化</p>
                        <p class="ps2">零门槛的项目管理工具</p>
                    </div>
                    <div class="comm3-lis">
                        <img src="./img-tb/tuanduixiezuo.png" alt="" loading="lazy">
                        <p class="ps1">团队协作 简单高效</p>
                        <p class="ps2">全员实时共享项目进展</p>
                        <p class="ps2">任务分配到人协作推进</p>
                    </div>
                    <div class="comm3-lis">
                        <img src="./img-tb/zhishiguanli.png" alt="" loading="lazy">
                        <p class="ps1">知识管理 记录所思 </p>
                        <p class="ps2">优雅记录每一个灵感瞬间</p>
                        <p class="ps2">体系化沉淀企业知识财产</p>
                    </div>
                </div>
                <div class="comm-title title-s3">我们是钉钉 <span>官方授权服务商</span></div>
                <div class="comm-title-lettle">[您可以联系我们,获取更好的方案支持和优惠政策]</div>
                <div class="common3 common3-dds">
                    <div class="comm3-lis">
                        <img src="./img-tb/guanfangshouquan-tuya.png" alt="" loading="lazy">
                        <p class="ps1">钉钉官方授权服务证书</p>
                    </div>
                    <div class="comm3-lis">
                        <img src="./img-tb/AAA质量服务诚信单位认证证书-tuya.png" alt="" loading="lazy">
                        <p class="ps1">AAA级质量服务诚信单位</p>
                    </div>
                    <div class="comm3-lis">
                        <img src="./img-tb/gaoxinjishuqiye-tuya.png" alt="" loading="lazy">
                        <p class="ps1">高新技术企业证书 </p>
                    </div>
                    <div class="comm3-lis">
                        <img src="./img-tb/yibaotongqiantai.png" alt="" loading="lazy">
                        <p class="ps1">壹宝通公司前台</p>
                    </div>
                </div>
                <div class="common2 common2-ss2">
                    <img src="./img-tb/组 94.png" alt="" loading="lazy">
                    我想咨询：钉钉Teambition收费标准是？
                    <div class="btn-zixun" @click="clickJump">立即咨询</div>
                </div>
                <div class="common5">
                    <div class="comm-title title-s3 title-s3-ssd">钉钉一体化项目管理系统</div>
                    <div class="comm-title-lettle comm-title-lettle-ssd">Teambition被广泛应用于跨部门协作、项目研发、敏捷研发、项目管理等各种场景</div>
                    <div class="common3 common3-ss5">
                        <div class="comm3-lis comm3-lis-blue">
                            <img src="./img-tb/kuabumenxiezuo.png" alt="" loading="lazy">
                            <p class="ps1">跨部门协作方案</p>
                             <span @click="clickJump">立即咨询</span>
                        </div>
                        <div class="comm3-lis comm3-lis-black">
                            <img src="./img-tb/xiangmuguanlixiezuo.png" alt="" loading="lazy">
                            <p class="ps1">项目管理协作方案</p>
                            <span @click="clickJump">立即咨询</span>
                        </div>
                        <div class="comm3-lis comm3-lis-blue">
                            <img src="./img-tb/yanfaguanlixiezuo.png" alt="" loading="lazy">
                            <p class="ps1">研发管理协作方案</p>
                            <span @click="clickJump">立即咨询</span>
                        </div>
                        <div class="comm3-lis comm3-lis-black">
                            <img src="./img-tb/minjieyanfaxiezuo.png" alt="" loading="lazy">
                            <p class="ps1">敏捷开发协作方案</p>
                            <span @click="clickJump">立即咨询</span>
                        </div>
                        <div class="comm3-lis">
                            <img src="./img-tb/renshixingzhengguanlixiezuo.png" alt="" loading="lazy">
                            <p class="ps1">人事行政管理协作方案</p>
                            <span @click="clickJump">立即咨询</span>
                        </div>
                    </div>
                </div>
                <div class="comm-title title-s3">行业个性化解决方案</div>
                <div class="comm-title-lettle colslo">Teambition能力全面开放，满足各行业个性化需求</div>
                <div class="common6">
                    <div class="common6-lis" @click="clickJump">
                        <p>互联网/科技行业</p>
                        <p>行业管理方案</p>
                        <img src="./img-tb/dianjishubiao.png" alt="" loading="lazy">
                    </div>
                    <div class="common6-lis" @click="clickJump">
                        <p>教育/培训/知识付费</p>
                        <p>行业管理方案</p>
                        <img src="./img-tb/dianjishubiao.png" alt="" loading="lazy">
                    </div>
                    <div class="common6-lis" @click="clickJump">
                        <p>零售/电商</p>
                        <p>行业管理方案</p>
                        <img src="./img-tb/dianjishubiao.png" alt="" loading="lazy">
                    </div>
                    <div class="common6-lis" @click="clickJump">
                        <p>地产/建筑/室内设计</p>
                        <p>行业管理方案</p>
                        <img src="./img-tb/dianjishubiao.png" alt="" loading="lazy">
                    </div>
                    <div class="common6-lis" @click="clickJump">
                        <p>广告/营销/媒体</p>
                        <p>行业管理方案</p>
                        <img src="./img-tb/dianjishubiao.png" alt="" loading="lazy">
                    </div>
                    <div class="common6-lis" @click="clickJump">
                        <p>汽车/物流/制造</p>
                        <p>行业管理方案</p>
                        <img src="./img-tb/dianjishubiao.png" alt="" loading="lazy">
                    </div>
                    <div class="common6-lis" @click="clickJump">
                        <p>咨询/律所/专业服务</p>
                        <p>行业管理方案</p>
                        <img src="./img-tb/dianjishubiao.png" alt="" loading="lazy">
                    </div>
                    <div class="common6-lis" @click="clickJump">
                        <p>了解更多</p>
                        <p>行业管理方案</p>
                        <img src="./img-tb/dianjishubiao.png" alt="" loading="lazy">
                    </div>
                </div>
                <div class="common7">
                    <div class="comm-title title-s3">开始使用 Teambition</div>
                    <div class="comm-title-lettle colslo">一起完成目标 让进步发生</div>
                    <div class="liubai-s"></div>
                    <span @click="clickJump">立即使用</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
   methods: {
    clickJump(){
        window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')
    }
   }
}
</script>
<style lang='less' scoped>
.tb-box{
    width: 100%;
    height: 100%;
    .banner-box{
        width:100% ;
        height: 906px;
        img{
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
    }
    .bom-main{
        width: 100%;
        background-color: #fff;
        .bom-main-center{
            width: 80%;
            height: 100%;
            margin: 0 auto;
            .common1{
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 50px;
                padding-top: 140px;
                .comm-lis{
                    width: 22%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding-top: 30px;
                    padding-bottom: 30px;
                    border-radius: 40px;
                    background-color: #007FFF;
                    p{
                        width: 100%;
                        padding: 26px;
                        color: #fff;
                        font-size: 23px;
                        letter-spacing: 1.5px;
                    }
                }
                .comm-lis2{
                    width: 50%;
                    margin-left: 30px;
                    margin-right: 30px;
                    background-color: #fff;

                    .top-lis{
                        height: 100px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 30px;
                        .left-img{
                            width: 92px;
                            height: 92px;
                        }
                        .logo-tb{
                            width: 570px;
                            height: 76px;
                            margin-left: 50px;
                            margin-right: 50px;
                        }
                        .right-img{
                            width: 92px;
                            height: 92px;
                        }
                    }
                    .bom-lis{
                        width: 100%;
                        font-size: 22px;
                        color: #000;
                        letter-spacing: 1.5px;
                        padding: 10px;
                        text-align: center;
                        padding-top: 40px;
                    }
                }
            }
            .common2{
                width: 100%;
                background-color: #fff;
                margin-top: 50px;
                padding: 40px 120px;
                font-size: 24px;
                color: #000;
                letter-spacing: 1.5px;
                line-height: 47px;
                text-align: left;
                box-shadow: 0px 0px 24px 1px rgba(0,0,0,0.16);

            }
            .common2-ss2{
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 14px 150px;
                img{
                    width: 98px;
                    height: 98px;
                    margin-right: 50px;
                }
                .btn-zixun{
                    padding: 8px 45px;
                    background-color: #007FFF;
                    color: #fff;
                    font-size: 24px;
                    letter-spacing: 2px;
                    border-radius: 7px;
                    margin-left: 550px;
                    cursor: pointer;
                }
            }
            .comm-title{
                width: 100%;
                padding: 100px;
                font-size: 40px;
                color: #000;
                font-weight: 600;
                letter-spacing: 2px;
                padding-top: 250px;
                span{
                    color: #007FFF;
                    font-size: 48px;
                }
            }
            .comm-title-lettle{
                width: 100%;
                padding: 50px;
                font-size: 23px;
                letter-spacing: 2px;
                padding-top: 25px;
                color: #F7C04D;
            }
            .colslo{
                color: #000;
            }
            .title-s2{
                padding-top: 150px;
            }
            .title-s3{
                padding-top: 150px;
                padding-bottom: 0px;

            }
            .title-s3-ssd{
                padding-top: 40px;
                padding-bottom: 0px;
                font-size: 35px;
                color: #fff;
            }
            .comm-title-lettle-ssd{
                color: #fff;
            }
            .common3{
                width: 100%;
                display: flex;
                justify-content: space-around;
                .comm3-lis{
                    width: 25%;
                    background-color: rgba(225,225,225,.4);
                    border-radius: 10px;
                    padding: 50px 80px;
                    img{
                        width: 106px;
                        height: 106px;
                    }
                    .ps1{
                        font-size: 22px;
                        color: #000;
                        margin-top: 20px;
                        margin-bottom: 20px;
                        letter-spacing: 1px;
                    }
                    .ps2{
                        font-size: 16px;
                        color: #444;
                        letter-spacing: 1px;
                        line-height: 28px;
                    }
                }
            }
            .common3-ss5{
                width: 100%;
                display: flex;
                justify-content: center;
                .comm3-lis{
                    width: 15%;
                    background-color: #fff;
                    margin-left: 1%;
                    margin-right: 1%;
                    padding: 30px 0px 44px 0px;
                    p{
                        color: #007FFF!important;
                        margin-bottom: 40px!important;
                    }
                    img{
                        width: 112px;
                        height: 112px;
                    }
                    span{
                        width: 100%;
                        padding: 12px 50px;
                        background-color: #007FFF;
                        border-radius: 4px;
                        color: #fff;
                        letter-spacing: 1.5px;
                        font-size: 22px;
                        cursor: pointer;
                    }
                }
                .comm3-lis-black{
                    background-color: rgb(25,25,25);
                    p{
                        color: #FFF!important;
                    }
                    span{
                        background-color: #fff;
                        color: #000;
                         cursor: pointer;
                    }
                }
            }
            .common-3ss{
                margin-top: 50px;
                .comm3-lis{
                    background-color: #fff;
                    padding: 0px;
                    padding-top: 30px;
                }
            }
            .common3-dds{
                margin-top: 50px;
                .comm3-lis{
                    background-color: #EBF5FF;
                    padding: 0px;
                    padding-top: 30px;
                }
                .comm3-lis:nth-child(1){
                    width: 20%;
                    img{
                        width: 224px;
                        height: 298px;
                    }
                    .ps1{
                        width: 100%;
                        background-color: #007FFF;
                        color: #fff;
                        padding: 15px 0px;
                        letter-spacing: 1.6px;
                    }
                }
                .comm3-lis:nth-child(2){
                    width: 20%;
                    img{
                        width: 224px;
                        height: 298px;
                    }
                    .ps1{
                        width: 100%;
                        background-color: #007FFF;
                        color: #fff;
                        padding: 15px 0px;
                        letter-spacing: 1.6px;
                    }
                }
                .comm3-lis:nth-child(3){
                    width: 25%;
                    img{
                        width: 439px;
                        height: 298px;
                    }
                    .ps1{
                        width: 100%;
                        background-color: #007FFF;
                        color: #fff;
                        padding: 15px 0px;
                        letter-spacing: 1.6px;
                    }
                }
                .comm3-lis:nth-child(4){
                    width: 25%;
                    img{
                        width: 439px;
                        height: 298px;
                    }
                    .ps1{
                        width: 100%;
                        background-color: #007FFF;
                        color: #fff;
                        padding: 15px 0px;
                        letter-spacing: 1.6px;
                    }
                }
            }
            .common4{
                width: 100%;
                .common4-lis{
                    width: 100%;
                    background-color: rgba(0,127,255,.08);
                    display: flex;
                    padding: 50px 220px;
                    .com-lis-left{
                        width: 50%;
                        text-align: left;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        .pp1{
                            font-size: 26px;
                            color: #000;
                            letter-spacing: 1px;
                            margin-bottom: 25px;
                            span{
                                color: #007FFF;
                                font-size: 28px;
                                margin-left: 20px;
                                font-weight: 600;
                                letter-spacing: 2px;
                            }
                        }
                        .pp2{
                            font-size: 22px;
                            color: #333;
                            letter-spacing: 1px;
                        }
                        .pp3{
                            font-size: 16px;
                            color: #333;
                            letter-spacing: 1px;
                            span{
                                color: #007FFF;
                            }
                        }
                        .pp3s1{
                            margin-top: 20px;
                        }
                        .liubai{
                            width: 100%;
                            height: 40px;
                        }
                        .pps2{
                            margin-top: 6px;
                        }
                        .pp3s2{
                            margin-top: 5px;
                        }
                        .bntn-box{
                            width: 220px;
                            height: 62px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background-color: #007FFF;
                            color: #fff;
                            font-size: 23px;
                            letter-spacing: 3px;
                            border-radius: 6px;
                            cursor: pointer;
                        }
                    }
                    .com-lis-right{
                        width: 50%;
                        height: 100%;
                        display: flex;
                        justify-content: flex-end;
                        img{
                            width: 474px;
                            height: 333px;
                        }
                    }
                }
                .common4-lis-ts{
                    width: 100%;
                    background: linear-gradient(180deg, #FFFFFF 0%, #DEF2FD 100%);
                    display: flex;
                    padding: 50px 220px;
                    .com-lis-right{
                        width: 50%;
                        text-align: right;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: flex-end;
                        .pp1{
                            font-size: 26px;
                            color: #000;
                            letter-spacing: 1px;
                            margin-bottom: 25px;
                            span{
                                color: #007FFF;
                                font-size: 28px;
                                margin-left: 20px;
                                font-weight: 600;
                                letter-spacing: 2px;
                            }
                        }
                        .pp2{
                            font-size: 22px;
                            color: #333;
                            letter-spacing: 1px;
                        }
                        .pp3{
                            font-size: 16px;
                            color: #333;
                            letter-spacing: 1px;
                            span{
                                color: #007FFF;
                            }
                        }
                        .pps2{
                            margin-top: 6px;
                        }
                        .pp3s2{
                            margin-top: 5px;
                        }
                        .pp3s1{
                            margin-top: 20px;
                        }
                        .liubai{
                            width: 100%;
                            height: 40px;
                        }
                        .bntn-box{
                            width: 220px;
                            height: 62px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background-color: #007FFF;
                            color: #fff;
                            font-size: 23px;
                            letter-spacing: 3px;
                            border-radius: 6px;
                            cursor: pointer;
                        }
                    }
                    .com-lis-left{
                        width: 50%;
                        height: 100%;
                        display: flex;
                        justify-content: flex-start;
                        img{
                            width: 474px;
                            height: 333px;
                        }
                    }
                }
            }
            .common5{
                width: 100%;
                margin-top: 100px;
                background-image: url('./img-tb/img-zhongjian-banner.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                padding: 30px 0px 90px 0px;
            }
            .common6{
                width: 100%;
                margin-top: 10px;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                padding-bottom: 80px;
                .common6-lis{
                    width: 23%;
                    height: 211px;
                    margin-right: 1%;
                    margin-left: 1%;
                    margin-bottom: 30px;
                    border-radius: 8px;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    position: relative;
                    padding-top: 60px;
                    cursor: pointer;
                    p{
                        font-size: 26px;
                        letter-spacing: 2px;
                        color: #fff;
                        margin-bottom: 13px;
                        text-align: left;
                        padding-left: 50px;
                    }
                    img{
                        width: 60px;
                        height: 60px;
                        position: absolute;
                        right: 0;
                        top: 0;
                        left: 280px;
                        bottom: 0px;
                        margin: auto;
                    }
                }
                .common6-lis:nth-child(1){
                    background-image: url('./img-tb/hulianwang.png');
                }
                .common6-lis:nth-child(2){
                    background-image: url('./img-tb/jiaoyupeixun.png');
                }
                .common6-lis:nth-child(3){
                    background-image: url('./img-tb/lingshoudianshang .png');
                }
                .common6-lis:nth-child(4){
                    background-image: url('./img-tb/dichanjianzhu.png');
                }
                .common6-lis:nth-child(5){
                    background-image: url('./img-tb/guanggaoyingxiao.png');
                }
                .common6-lis:nth-child(6){
                    background-image: url('./img-tb/qichezhizao.png');
                }
                .common6-lis:nth-child(7){
                    background-image: url('./img-tb/zixunlvshuo.png');
                }
                .common6-lis:nth-child(8){
                    background-image: url('./img-tb/liaojiegengduo.png');
                }
            }
            .common7{
                width: 100%;
                background: linear-gradient(180deg, #BEDDFF 0%, #FDFFFF 100%);
                padding: 0px 0px 100px 0px;
                margin-bottom: 50px;
                .liubai-s{
                    width: 100%;
                    height: 50px;
                }
                span{
                    padding: 18px 50px;
                    background-color: #007FFF;
                    color: #fff;
                    border-radius: 6px;
                    font-size: 24px;
                    cursor: pointer;
                    letter-spacing: 2px;
                }
            }
        }
    }
}
</style>
